// extracted by mini-css-extract-plugin
export default {"root":"SectionAnimatedWrapper_root__JMTAG"};